import React from 'react';
import { exportEventName } from '.';
import useChartReflow from '../../../../hooks/generic/charts/useChartReflow';
import i18n from '../../../../utils/ChrI18n';
import { isPresent } from '../../../../utils/CoreExtensions/ArrayExtensions';
import { safeMutate } from '../../../../utils/GeneralUtils';
import ChrLink from '../../../generic/Utils/ChrLink';
import { MetricUId } from '../../Metrics/constants';
import { getMetricDataFromArray } from '../../Metrics/utils';
import PieChart from '../../Reports/templates/PieChart';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import getChartConfig, { chartOnlyMetrics } from './utils';


const Body = (props) => {
  const { metrics, name } = props;
  const numericMetrics = metrics.filter(metric => !chartOnlyMetrics.includes(metric.uId));
  const propsForNumericMetrics = safeMutate(props, draftProps => {
    draftProps.metrics = numericMetrics;
  });
  const { chartWrapperReference, chartCallbackFunction } = useChartReflow();
  const isSplitWidget = isPresent(numericMetrics);
  const totalMeetingRequests = getMetricDataFromArray(metrics, MetricUId.TOTAL_MEETING_REQUESTS);
  const childClass = `col-12 col-md-6 ${!isSplitWidget && "mx-auto"} dynamic-grid-item-child`;

  return (
    <div className="d-flex flex-column custom-max-height-550-px p-3 overflow-auto">
      <div className='row no-gutters' ref={ chartWrapperReference }>
        <div className={ `cui-widget-pie-chart ${childClass}` }>
          <PieChart
            chartOptions={ getChartConfig({ metrics, name }) }
            configs={ { export: true, exportEventName } }
            callbackFn={ chartCallbackFunction }
          />
        </div>
        {
          isSplitWidget &&
          <div className={childClass}>
            <WidgetBodyWrapper { ...propsForNumericMetrics } wrapperPadding="py-3" />
          </div>
        }
      </div>
      {
        totalMeetingRequests.expiryDetails &&
        <div className='cui-widget-info-bg d-flex flex-gap-10 p-3 border-radius-0-25 font-bold'>
          <i className="fa-regular fa-gear mt-1" />
          <span>{ totalMeetingRequests.expiryDetails.infoText }</span>
          <ChrLink newTab href={ totalMeetingRequests.expiryDetails.url }>({ i18n.t("display_string.Change") })</ChrLink>
        </div>
      }
    </div>
  );
};

export default Body;
